/**
 * "Sign out" on every portal screen — the driver's day, the Operator Admin
 * and the dispatch board.
 *
 * Clears the portal session, then does a FULL load: every screen and cached
 * response is dropped with it, and the guard re-reads storage.
 *
 * Where it lands depends on how the person gets back in, which is the one
 * thing that differs between them. A driver or operator needs a link from
 * the office, so `/portal` and its gate is the honest destination. A
 * DISPATCHER signs in with their own dashboard account, so sending them to
 * the gate — a Hungarian screen about asking for a WhatsApp link — would be
 * telling them to do something that is not their way in at all.
 *
 * Read BEFORE the session is cleared, because clearing it is what forgets
 * which kind they were.
 */
import { clearPortalSession, getPortalPrincipal, isStaffPortalSession } from '../../Services/PortalApi';
import { clearSession } from '../../Services/SessionRenewal';
import { PORTAL_USER_KINDS } from '../../config/config';

export default function signOutOfPortal() {
  const backTo = getPortalPrincipal()?.kind === PORTAL_USER_KINDS.DISPATCHER
    ? '/portal/login'
    : '/portal';

  // A staff session is one session across both surfaces — the same token in
  // both stores — so signing out of the board drops the dashboard's copy
  // too. Leaving it would put them back on the board by simply typing the
  // URL, having just asked to leave.
  if (isStaffPortalSession()) clearSession();

  clearPortalSession();
  window.location.assign(backTo);
}
